import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c8dd9921dc9001460a629/travelgateway/src/app/performance-analytics/components/PerformanceAnalyticsInteractive.tsx");
